
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[authorID]/practices",
      function () {
        return require("private-next-pages/[authorID]/practices.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[authorID]/practices"])
      });
    }
  